/**
 * Accepts an int representing minutes and will convert it into a string
 * representing the amount of hours and minutes
 *
 * e.g. minutes = 130, returns `2 hours 10 minutes`
 *
 * @param {Number} minutes
 * @returns {String}
 */
export const minutesToHoursMinsString = (minutes) => {
  if (typeof minutes !== 'number')
    throw Error('Invalid data type for minutes (Expected Number)')

  let hours = 0
  let remainingMinutes = 0
  let minutesString = '0 minutes'
  let hourString = ''

  hours = Math.floor(minutes / 60)
  remainingMinutes = minutes % 60
  minutesString =
    minutes === 0
      ? `${remainingMinutes} minutes`
      : remainingMinutes > 2
      ? `${remainingMinutes} minutes`
      : remainingMinutes === 0
      ? ''
      : `${remainingMinutes} minute`

  hourString = hours > 1 ? `${hours} hours` : hours < 1 ? '' : `${hours} hour`

  return `${hourString ? `${hourString} ` : ''}${minutesString}`
}
